"use client";

import { useTranslations } from "next-intl";
import { Link, Stack, Text } from "@leabankab/component-library";
import { useCookieConsent } from "@leabankab/component-library/cookie-consent/react";

export const Footer = () => {
	const t = useTranslations("components.Footer");
	const tConsent = useTranslations("components.CookieConsent");
	const { openSettings } = useCookieConsent();

	return (
		<footer className="mt-auto border-t border-border-subtle">
			<Stack
				direction={{ base: "column", md: "row" }}
				gap={1}
				align="start"
				justify="between"
				className="p-2"
			>
				<Text>{t("copyright")}</Text>
				<Link render={<button type="button" />} onClick={openSettings}>
					{tConsent("settingsLabel")}
				</Link>
			</Stack>
		</footer>
	);
};
